import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import Fa from 'react-fontawesome';

class DeleteJobMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
    };
    this.toggleConfirm = this.toggleConfirm.bind(this);
  }

  toggleConfirm() {
    if (this.state.confirm) {
      // already confirm
      this.deleteJob();
    } else {
      this.setState({ confirm: true });
    }
  }

  deleteJob() {
    if (this.props.deleting) {
      return;
    }
    this.props.requestDelete(this.props.job)
      .then(
        () => {
          this.setState({ confirm: false });
        },
        () => {
          this.setState({ confirm: false });
        },
      );
  }

  render() {
    const { deleting, disabled } = this.props;
    const { confirm } = this.state;
    return (
      <MenuItem disabled={deleting || disabled} onClick={this.toggleConfirm}>
        {!deleting &&
          <span>
            {!confirm && <span><Fa name="trash" /> Delete</span>}
            {confirm && <span className="text-danger">Are you sure?</span>}
          </span>
        }
        {deleting && <span><Fa name="spinner" spin /> Deleting</span>}
      </MenuItem>
    );
  }
}

DeleteJobMenu.propTypes = {
  job: PropTypes.shape({
    _id: PropTypes.oneOfType([
      PropTypes.string,
    ]).isRequired,
  }).isRequired,
  requestDelete: PropTypes.func,
  deleting: PropTypes.bool,
  disabled: PropTypes.bool,
};

DeleteJobMenu.defaultProps = {
  disabled: false,
  deleting: false,
  requestDelete: () => Promise.reject(new Error('Need handler')),
};

export default DeleteJobMenu;
